import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './portal.css';
import './aboutmanager-theme.generated.css';
import './aboutmanager-theme.css';
import './mobile-workspace.css';
import { applyTheme, readTheme } from './theme-preference';

applyTheme(readTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
